export const BoardMembershipRoles = {
  OWNER: 'owner',
  EDITOR: 'editor',
  VIEWER: 'viewer',
};

export const ListSortTypes = {
  NAME_ASC: 'name_asc',
  DUE_DATE_ASC: 'dueDate_asc',
  CREATED_AT_ASC: 'createdAt_asc',
  CREATED_AT_DESC: 'createdAt_desc',
};

export const ActivityTypes = {
  CREATE_CARD: 'createCard',
  MOVE_CARD: 'moveCard',
  COMMENT_CARD: 'commentCard',
  ADD_MEMBER_TO_CARD: 'addMemberToCard',
  CHANGE_DUE_DATE: 'changeDueDate',
  ADD_ATTACHMENT: 'addAttachment',
};

export const RelationTypes = {
  NONE: 'NONE',
  DEPENDS_ON: 'DEPENDS_ON',
  SUB_TASK: 'SUB_TASK',
  SPECIFIES: 'SPECIFIES',
  DEVELOPS: 'DEVELOPS',
  TESTS: 'TESTS',
};

export const Roles = {
  PLATFORM_ADMIN: 'platform_admin',

  PROJECT_MANAGER: 'project_manager',

  BOARD_OWNER: 'board_owner',
  BOARD_EDITOR: 'board_editor',
  BOARD_VIEWER: 'board_viewer',

  CARD_EDITOR: 'card_editor',
  CARD_VIEWER: 'card_viewer',
};

export const Permissions = {
  USER_MANAGE: 'user_manage',

  PROJECT_CREATE: 'project_create',
  PROJECT_VIEW: 'project_view',
  PROJECT_MANAGE: 'project_manage',

  BOARD_VIEW: 'board_view',
  BOARD_EDIT: 'board_edit',
  BOARD_ADMIN: 'board_admin',

  CARD_VIEW: 'card_view',
  CARD_EDIT: 'card_edit',
  CARD_DELETE: 'card_delete',

  COMMENT_CREATE: 'comment_create',
  COMMENT_UPDATE: 'comment_update',
  COMMENT_DELETE: 'comment_delete',

  ATTACHMENT_CREATE: 'attachment_create',
  ATTACHMENT_UPDATE: 'attachment_update',
  ATTACHMENT_DELETE: 'attachment_delete',
};

export const ResourceTypes = {
  PLATFORM: 'Platform',

  PROJECT: 'Project',

  BOARD: 'Board',

  CARD: 'Card',

  // INVENTORY: 'inventory',
  // VEHICLE: 'vehicle',
  // MAINTENANCE: 'maintenance',
  // INTENDANCE: 'intendance',
};
